module.exports = __webpack_public_path__ + "static/fonts/Fact-Medium.f619695.eot";